import { FieldAPI } from '@philips-emr/tws-components';
import { Validator } from '@philips-emr/tws-core/lib/services/model-service';

import { catchRenderException } from './utils';

function setRequiredField(isRequired: boolean, field: FieldAPI): void {
  const value = 'required';

  catchRenderException(() => {
    if (isRequired) {
      if (!checkExistsValidatorRequired(field)) {
        field.addValidator({ name: value });
      }
    } else {
      field.removeValidator(value);
    }
  });

}

function checkExistsValidatorRequired(field: FieldAPI): boolean {
  if (!field) {
    return false;
  }

  const validators = field.getValidators() as unknown as Validator[];
  return !!validators.find(validator => validator.name === 'required');
}

export {
  setRequiredField,
  checkExistsValidatorRequired,
};
